// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Huq3g","footer":"styles_footer__1QDH-"};